import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Row,
    Col,
} from 'reactstrap';

// import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import firebase, { functions } from 'firebase';

function TeachSignUp({ onClick, setUserData, notify, getUsers }) {
    const { register, handleSubmit, errors } = useForm();
    const [batchList, setBatchList] = useState([]);
    const [showpassword, setShowPassword] = useState(false);
    const [selectedBatches, setselectedBatches] = useState([]);

    const teacherPermision = [
        { label: 'Book Management', value: 'Book_Management' },
        { label: 'Mock Management', value: 'Quiz_Management' },
        { label: 'Batch Management', value: 'Batch_Management' },
        { label: 'Session Management', value: 'Session_Management' },
    ]
    const getBatch = () => {
        db.collection('Batch')
            .where('type', '==', 'batch')
            .get()
            .then((querySnapshot) => {
                let data = querySnapshot.docs.map((doc) => { return { label: doc.data().batchName, value: doc.data().itemID } });
                setBatchList(data);
            });
    };

    useEffect(() => {
        getBatch()
    }, [])

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#272a3d' : 'black',
            padding: 10,
        }),
        control: () => ({
            display: 'none',
        }),
    };


    const createUser = (data) => {
        document.querySelector('#loading-indicator').style.display = 'flex';
        const userData = {
            firstname: data.firstname,
            lastname: data.lastname,
            mobile: data.mobile,
            isAdmin: true,
            isTeacher: true,
            disabled: false,
            email: data.email,
            permissions: teacherPermision,
            password: data.password,
            username: data.username,
            isBatchManage: selectedBatches,
            status:0
        };
        const addSystemUser = firebase.functions().httpsCallable('addSystemUser');

        addSystemUser(userData)
            .then((result) => {
                if (result.data.hasError === false) {

                    const _uniqueID = result.data.user.uid;
                    const finalData = { ...userData, _uniqueID };

                    db.collection('zSystemUsers')
                        .doc(_uniqueID.toString())
                        .set(finalData)
                        .then(function () {

                            setUserData((prev) => [...prev, finalData]);
                            onClick();
                            document.querySelector('#loading-indicator').style.display = 'none';
                            getUsers();
                            notify('User created successfully', false);
                        })
                        .catch(function (error) {
                            notify(error.toString(), true);
                        });
                } else {
                    document.querySelector('#loading-indicator').style.display = 'none';
                    notify(result.data.message.errorInfo.message, true);
                }
            })
            .catch((err) => {
                document.querySelector('#loading-indicator').style.display = 'none';
                notify(
                    err.message !== undefined
                        ? err.message.toString()
                        : err.toString() || 'Something went wrong',
                    true
                );
            });
    }

    return (
        <div className='content'>
            <Row>
                <Col md='12'>
                    <Card style={{ margin: 0 }}>
                        <CardHeader>
                            <h5 className='title'>Teacher Registration</h5>
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={handleSubmit(createUser)}>
                                <Row className='lg' md='1'>
                                    <Col className='lg' md='3'>
                                        <FormGroup>
                                            <label>First Name*</label>
                                            <input
                                                className='form-control'
                                                {...register('firstname', { required: true })}
                                                name='firstname'
                                                placeholder='First Name'
                                                type='text'
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='3'>
                                        <FormGroup>
                                            <label>Last Name*</label>
                                            <input
                                                className='form-control'
                                                {...register('lastname')}
                                                name='lastname'
                                                placeholder='Last Name'
                                                type='text'
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Username*</label>
                                            <input
                                                className='form-control'
                                                placeholder='username'
                                                type='text'
                                                name='username'
                                                required
                                                {...register('username', {
                                                    required: true,
                                                    minLength: 6,
                                                })}
                                            />

                                            {errors?.username &&
                                                errors?.username?.type === 'minLength' && (
                                                    <span
                                                        style={{
                                                            fontSize: '10px',
                                                            position: 'absolute',
                                                            bottom: '-20px',
                                                            color: 'red',
                                                        }}
                                                    >
                                                        Username should be atleast 6 digits.
                                                    </span>
                                                )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Email*</label>
                                            <input
                                                className='form-control'
                                                {...register('email')}
                                                name='email'
                                                placeholder='user@user.com'
                                                type='email'
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Password*</label>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'end',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <input
                                                    className='form-control'
                                                    {...register('password', {
                                                        required: true,
                                                        minLength: 6,
                                                    })}
                                                    required
                                                    name='password'
                                                    type={showpassword ? 'text' : 'password'}
                                                    placeholder='Password'
                                                />
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        paddingRight: '15px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => setShowPassword(!showpassword)}
                                                >
                                                    <i className={`fa fa-eye${showpassword ? '-slash' : ''}`} aria-hidden='true'></i>
                                                </div>

                                            </div>

                                            {errors?.password &&
                                                errors?.password.type === 'minLength' && (
                                                    <span
                                                        style={{
                                                            fontSize: '10px',
                                                            position: 'absolute',
                                                            bottom: '-20px',
                                                            color: 'red',
                                                        }}
                                                    >
                                                        Password should be atleast 6 digits.
                                                    </span>
                                                )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Mobile*</label>
                                            <input
                                                className='form-control'
                                                {...register('mobile', {
                                                    required: true,
                                                    minLength: 10,
                                                    maxLength: 10,
                                                    min: 6000000000,
                                                })}
                                                name='mobile'
                                                placeholder='Mobile'
                                                type='number'
                                                required
                                            />
                                            {errors?.mobile && errors?.mobile.type !== 'required' && (
                                                <span
                                                    style={{
                                                        fontSize: '10px',
                                                        position: 'absolute',
                                                        bottom: '-20px',
                                                        color: 'red',
                                                    }}
                                                >
                                                    Please Enter Valid Mobile No.
                                                </span>
                                            )}

                                            {/* {errors !== '' ? <p style={{ color: 'red' }}>{mobileError}</p> : ''} */}
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='6'>
                                        <FormGroup className='permissions-multiselect'>
                                            <label>Select Batch</label>
                                            <ReactMultiSelectCheckboxes
                                                styles={customStyles}
                                                options={batchList}
                                                value={batchList.filter(batch => selectedBatches.includes(batch.value))}
                                                onChange={(option) => {
                                                    setselectedBatches(option.map(val => val.value));
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div>
                                    <Button color='info' type='submit'>
                                        Submit
                                    </Button>
                                    <Button onClick={onClick}>Back</Button>
                                </div>
                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default TeachSignUp;
